import styled, { css } from 'styled-components'

interface DefaultButtonProps {
  variant: 'primary' | 'secondary' | 'plain' | 'error' | 'outlinedBlue';
  isTakingAction?: boolean;
  minWidth?: string;
  padding?: string;
}

const bgColors = {
  primary: '#3D6666',
  secondary: '#FFFFFF',
  plain: 'inherit',
  error: '#E84242',
  outlinedBlue: '#FFFFFF'
}

const fontColor = {
  primary: '#FFFFFF',
  secondary: '#3D6666',
  plain: '#353744',
  error: '#FFFFFF',
  outlinedBlue: '#4F4D83'
}

const borders = {
  primary: '2px solid #3D6666',
  secondary: '2px solid #3D6666',
  plain: 'none',
  error: '2px solid #E84242',
  outlinedBlue: '1px solid #4F4D83'
}

const disabledCss = {
  primary: 'opacity:0.7;',
  secondary: 'opacity:1;border-color:#CED8D4;color:#CED8D4;',
  plain: 'color:#7B7C82;opacity:0.8;color: #CED8D4;',
  error: 'opacity:0.7;',
  outlinedBlue: 'opacity:0.7;'
}

export const DefaultButton = styled.button<DefaultButtonProps>`
  background: ${props => bgColors[props.variant]};
  border: ${props => borders[props.variant]};
  padding: ${props => props.padding ?? '12px 28px'};
  min-width: ${props => props.minWidth ?? '160px'};
  font-weight: 800;
  font-size: 18px;
  line-height: 27px;
  color: ${props => fontColor[props.variant]};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: ${props => props.variant === 'outlinedBlue' ? '3px' : '0'};
  white-space: nowrap;

  img {
    height: 27px;
    width: 27px;
  }

  svg {
    min-width: 18px;
    min-height: 18px;
  }
  
  &:disabled {
    cursor: not-allowed;
    ${({ isTakingAction, variant }) => !isTakingAction && disabledCss[variant]}
  }
`